// Menu hover previews (V3.1) — one dark studio shot per collection, hovers
// only on the 3 collections. Images share a pure-black bg = menu bg, so they
// merge seamlessly. Sizing is volume-true: Epos 60ml bottle = 80% of the
// wheel span (top of first item → bottom of last); Oud 50ml / Cristallo 50ml
// scaled so bottle VOLUME (w²·h from the photo's bottle bbox) tracks real ml.
// Constants below measured from the source photos (PIL bbox scan, lum>25).
//
// THEME COPY - differs from site/js/menu-previews.js in two marked lines (parity pass, 21 Sep): the
// store's menu links are /collections/<handle>, and the three shots load from the theme's assets
// (assets/menu-epos.jpg, menu-oud.jpg, menu-cristallo.jpg). It shipped the static keys and img/ paths,
// so no preview ever showed on the store.
(function () {
  var menu = document.getElementById('mobileMenu');
  var wheel = document.getElementById('menuWheel');
  if (!menu || !wheel) return;
  // hover previews are a pointer-device feature — OFF on touch/mobile so a
  // tap never flashes a preview or delays navigation
  if (!matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var V = '?v=323';
  // imgW/imgH: native px · bTop/bBot: bottle bbox top/bottom as frac of imgH
  // bCx: bottle centre x as frac of imgW · rel: bottle-height scale vs Epos
  var SHOTS = {
    'collection-epos.html':      { src: 'img/menu-epos.jpg',      imgW: 1024, imgH: 1536, bTop: 0.273, bBot: 0.818, bCx: 0.486, bW: 0.580, rel: 1 },
    'collection-oud.html':       { src: 'img/menu-oud.jpg',       imgW: 937,  imgH: 1678, bTop: 0.257, bBot: 0.724, bCx: 0.504, bW: 0.509, rel: 0.95 },
    'collection-cristallo.html': { src: 'img/menu-cristallo.jpg', imgW: 941,  imgH: 1672, bTop: 0.406, bBot: 0.764, bCx: 0.496, bW: 0.692, rel: 0.709 }
  };

  var panel = document.createElement('div');
  panel.className = 'mzp-panel';
  panel.setAttribute('aria-hidden', 'true');
  menu.appendChild(panel);

  function zone() {
    var items = [].slice.call(wheel.querySelectorAll('.ow-item'));
    if (!items.length) return null;
    var first = items[0].getBoundingClientRect();
    var last = items[items.length - 1].getBoundingClientRect();
    var left = 1e9, right = 0;
    items.forEach(function (el) {
      var r = el.getBoundingClientRect();
      left = Math.min(left, r.left); right = Math.max(right, r.right);
    });
    return {
      top: first.top, bottom: last.bottom,
      x0: right + left, x1: innerWidth - left,
      span: last.bottom - first.top
    };
  }

  function clear() { panel.innerHTML = ''; panel.classList.remove('mzp-on'); }

  function show(s) {
    var z = zone(); if (!z) return;
    var bottleH = z.span * 0.8 * s.rel;
    var bFrac = s.bBot - s.bTop;
    var imgH = bottleH / bFrac;
    var imgW = imgH * (s.imgW / s.imgH);
    // no shrink — photo sits behind the text layer, so the bottle keeps its
    // grand size and simply extends leftward behind the text on narrow windows;
    // only the right margin is pinned so it never leaves the viewport.
    var half = imgW * s.bW / 2;
    // biased right so the base glow clears the menu text on the left
    var cx = Math.min((z.x0 + z.x1) / 2 + (z.x1 - z.x0) * 0.12, z.x1 - half);
    var left = cx - imgW * s.bCx;                 // bottle centred in zone
    var top = z.bottom - imgH * s.bBot;           // bottle base on zone floor
    var img = document.createElement('img');
    // THEME COPY: window.MZ.assetBase (layout/theme.liquid) is the theme's assets/ folder on the CDN
    img.src = (window.MZ && window.MZ.assetBase ? window.MZ.assetBase + s.src.replace('img/', '') : s.src) + V;
    img.className = 'mzp-bottle';
    img.style.cssText = 'left:' + left + 'px;top:' + top + 'px;height:' + imgH + 'px;';
    panel.appendChild(img);
  }

  wheel.addEventListener('pointerover', function (e) {
    var it = e.target.closest && e.target.closest('.ow-item');
    if (!it) return;
    var href = (it.getAttribute('href') || '').split('?')[0];
    href = href.replace(/^\/collections\/([a-z]+)$/, 'collection-$1.html');   // THEME COPY
    clear();
    var s = SHOTS[href];
    if (s) { show(s); panel.classList.add('mzp-on'); }
  });
  wheel.addEventListener('pointerleave', clear);
  menu.addEventListener('transitionend', function (e) { if (e.target === menu && !menu.classList.contains('open')) clear(); });
})();
